import { reportError } from "utils/reportError";
import { isChunkLoadError, reloadForStaleChunkOnce } from "utils/staleChunkReload";

/** Register global handlers for uncaught async errors. */
export const setupGlobalErrorHandlers = () => {
    window.addEventListener("unhandledrejection", (event) => {
        // A failed dynamic import of a stale route chunk after a deploy can
        // surface here as an uncaught rejection — recover with one reload.
        if (isChunkLoadError(event.reason) && reloadForStaleChunkOnce()) {
            return;
        }
        reportError(event.reason, { source: "unhandledrejection" });
    });

    // Vite dispatches `vite:preloadError` when a modulepreload / dynamic-import
    // preload fails — the classic "stale chunk after an upgrade" signal. Recover
    // with a single guarded full-page reload instead of surfacing the error.
    window.addEventListener("vite:preloadError", (event) => {
        event.preventDefault();
        if (!reloadForStaleChunkOnce()) {
            reportError((event as unknown as { payload?: unknown }).payload, {
                source: "vite:preloadError",
            });
        }
    });
};
